import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IShift } from '../../../../../core/interfaces/shift';
import { ProductionByStreetService } from '../../../../services/production-by-street/production-by-street.service';
import { IExtractionPointModal } from '../../../../../widget/interfaces/production-by-street';
import { Subscription } from 'rxjs';
import { firstLetterUpper } from '../../../../../../../../projects/common/src/app/services/utils/util.service';
import { LanguageService } from '../../../../../../../../projects/common/src/app/services/parameters/language/language.service';
import { ProductionByTypetruckService } from 'src/app/modules/dashboard/services/production-by-typetruck/production-by-typetruck.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { AuthenticationService } from 'projects/authentication/src/app/services';

@Component({
  selector: 'app-production-by-street-modal',
  templateUrl: './production-by-street-modal.component.html',
  styleUrls: ['./production-by-street-modal.component.scss'],
})
export class ProductionByStreetModalComponent implements OnInit, OnDestroy {
  @Input() public modalSubtitle: string;
  @Input() public streetId: number;
  @Input() public streetName: string;
  @Input() public shift: IShift;
  @Input() public date: string;
  @Input() public shiftLabel: string;
  @Input() public zoneName: string;

  public activeTab = 'extractionPointChart';
  public modalData: IExtractionPointModal;
  public extractionPointDetailSubscription: Subscription;
  public streetLabelModalTitle: string;

  public logoutSub: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    protected prodByStreetService: ProductionByStreetService,
    protected prodByModel: ProductionByTypetruckService,
    protected langService: LanguageService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected authService: AuthenticationService,
  ) {}

  /**
   * On component init
   */
  public ngOnInit(): void {
    const resultType = 1;
    this.streetLabelModalTitle = firstLetterUpper(this.langService.message('street'));
    this.extractionPointDetailSubscription = this.prodByStreetService
      .getExtractionPointDetailByStreet(this.date, this.shift.shiftId, this.streetId, resultType)
      .subscribe((data) => {
        this.modalData = data;
      });

    // 👮🏽 subscribe to the token expired event to close the modal
    this.logoutSub = this.authService.tokenExpired$.subscribe(() => {
      this.activeModal.dismiss('logout');
    });
  }

  /**
   * On component init
   */
  public ngOnDestroy(): void {
    if (this.extractionPointDetailSubscription) {
      this.extractionPointDetailSubscription.unsubscribe();
    }

    // Unsubscribe to avoid memory leaks
    if (this.logoutSub) {
      this.logoutSub.unsubscribe();
    }
  }

  public changeTab($event: any) {
    let customEvent = {};
    if ($event.index === 0) {
      customEvent = {
        tab_modal: 'production-by-street-chart',
      };
    }
    if ($event.index === 1) {
      customEvent = {
        tab_modal: 'production-by-street-statistics',
      };
    }
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }
}
